import { useEffect, useState } from 'react';

const loadedBackgroundImages = new Set();

const useBackgroundImagePreload = (src) => {
  const [isLoaded, setIsLoaded] = useState(() => !src || loadedBackgroundImages.has(src));

  useEffect(() => {
    if (!src) {
      setIsLoaded(true);
      return undefined;
    }

    if (loadedBackgroundImages.has(src)) {
      setIsLoaded(true);
      return undefined;
    }

    let isMounted = true;
    const image = new Image();

    const markLoaded = () => {
      loadedBackgroundImages.add(src);
      if (isMounted) {
        setIsLoaded(true);
      }
    };

    image.onload = markLoaded;
    image.onerror = markLoaded;
    image.src = src;

    if (image.complete) {
      markLoaded();
    }

    return () => {
      isMounted = false;
    };
  }, [src]);

  return isLoaded;
};

export default useBackgroundImagePreload;
